export default __webpack_public_path__ + "static/media/kitten1XS.7297d01e.webp";